// Network-Detail-Snapshot für /network. Liefert die volle
// NetworkTopology[] + OpenWrt-Agents -- das was die Page rendert.
// Aggregat (devices_online/total) bleibt im network-summary für die
// Dashboard-Card.
//
// Seit 02.11.2026 ohne eigenen Abruf und Takt: beides kommt über das
// Homelab-Protokoll (netz.<id>.cluster, openwrt.<id>.stand; docs/protokoll.md
// › „Netzwerk über das Protokoll“) aus dem gemeinsamen Netz-Stand
// (netz.svelte.ts), REST nur beim Start und nach Aktionen
// (refreshNetworkDetails). Der OpenWrt-Agent meldet im ~5-s-Takt -- solange eine
// Seite das Präsenz-Abo "openwrt:live" hält (Network.svelte, Dashboard.svelte).
//
// SWR: ja -- Page rendert beim Reload den letzten Topology-Baum
// sofort, statt erst "lade...".

import { getNetzCluster, getNetzRouter, refreshNetz, startNetz } from "./netz.svelte";
import type { NetworkTopology } from "./types";

export interface OpenwrtTunnel {
  name: string;
  up: boolean;
  uptime: number;
  ipv4?: string;
  ipv6?: string;
}

export interface OpenwrtTailscale {
  online: boolean;
  ipv4?: string;
  backend?: string;
  rx_mbps?: number;
  tx_mbps?: number;
}

export interface OpenwrtSnapshot {
  /** Kennung des Routers: Host aus dem MQTT-Topic (= SSH-Alias). Zwei
   *  Router können denselben uci-Namen tragen, `host` taugt darum nicht
   *  als Schlüssel. */
  router?: string;
  /** Hostname aus uci, nur zur Anzeige */
  host: string;
  /** MQTT-Topic des Agenten, z. B. homelab/openwrt/openwrt/wan */
  topic?: string;
  wan_iface: string;
  rx_mbps: number;
  tx_mbps: number;
  tunnels: OpenwrtTunnel[];
  tailscale?: OpenwrtTailscale;
  last_seen: string;
}

let _off: (() => void) | undefined;

export function startNetworkDetails(): void {
  if (_off) return;
  _off = startNetz();
}

export function stopNetworkDetails(): void {
  _off?.();
  _off = undefined;
}

export function getNetworkTopology(): NetworkTopology[] | undefined {
  return getNetzCluster();
}

export function getOpenwrtAgents(): OpenwrtSnapshot[] | undefined {
  return getNetzRouter();
}

/** Holt Topologie und Agenten sofort per REST -- nach einer Aktion, deren
 *  Ergebnis die Seite gleich zeigen soll (das Protokoll braucht einen Moment). */
export function refreshNetworkDetails(): Promise<void> {
  return refreshNetz(["cluster", "router"]);
}
